import React from "react";

const LoginBanner = () => {
  return (
    <div className="relative">
      <img src="./img/Login-Banner.png" alt="" className="h-svh w-full" />
      <div className="absolute inset-0 flex flex-wrap flex-col justify-center items-center px-6 md:px-20">
        <div className="text-white  text-5xl md:text-6xl">
          The biggest risk of all, is not taking one
        </div>
        <div className="mt-6 text-white">
          Create a free account and get full access to all features for free. No
          credit card needed. Trusted by over 4,000 professionals.
        </div>
      </div>
    </div>
  );
};

export default LoginBanner;
